import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import search_svg from "../../assets/images/svg/search.svg";
import closeInput from "../../assets/images/svg/closeInput.svg";
import PopupMenu from "../../components/PopupMenu/PopupMenu";
import RadioGroup from "../../components/Reports/RadioGroup";
import {
  exportDataMenu,
  oneDayDif,
  REPORTS_PAGE,
  transectionsTimePeriodRadioBtnsData,
  VIEW_TRANSACTIONS,
} from "../../utils/constants";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import FilledButton from "../../components/SelectButton/FilledButton";
import EmptyButton from "../../components/SelectButton/EmptyButton";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import Table from "../../components/Table2";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import {
  commaSeperated,
  commaSeperated2,
  convertDateToObj,
  displayUnit,
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getDateString,
  getDecodedToken,
  getDisplayDate,
  getDisplayDateForExport,
  getExcelDate2,
  getExcelNumData2,
  getExcelPdfName,
  getPrintDate,
  getTextColor,
  lakhAmt,
  logEvents,
  padNumber,
  // printDocument,
  trackEventWithScreen,
} from "../../utils/functions";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import emptyIcon from "../../assets/images/svg/empty.svg";
import ModalFamilyWithCheckboxes from "../../components/ModalFamily/ModalFamilyWithCheckboxes";
//import PdfTable from "../../components/PdfTable/PdfTable";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import DatePicker2 from "../../components/Reports/DatePicker2";
import { useNavigate } from "react-router";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { getCookie } from "../../utils/cookie";
import { useCallback } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import AssetClassesCheckBox from "../../components/Reports/AssetClassesCheckBox";
import NoDataText from "../../components/NoDataText/NoDataText";

const dateCellRenderer = (data) => {
  const dateValue = getDisplayDate(data);

  return (
    <p
      style={{ fontFamily: "Encode Sans", whiteSpace: "nowrap" }}
      className="date_cell"
    >
      {" "}
      {dateValue ? <span>{dateValue}</span> : <NoDataText />}
    </p>
  );
};

const dateCellRendererForExportExcelPDF = (data) => {
  return getDisplayDateForExport(data) || "-";
};
const qtyCellRenderer = (data) => {
  return <p className="qty_cell font-roboto ">{commaSeperated(data) || "-"}</p>;
};

const navCellRenderer = (data) => {
  return (
    <p className="qty_cell font-roboto">₹ {commaSeperated2(data) || "-"}</p>
  );
};

const amtCellRendererForRecent = (data) => {
  return (
    <p className="qty_cell font-roboto">
      {data?.actual_value ? (
        <p>
          {`₹ ${commaSeperated2(data?.value)}`}{" "}
          <span className="unitFont">{`${displayUnit(data.value_type)}`}</span>
        </p>
      ) : (
        "-"
      )}
    </p>
  );
};

const ttypeCellRenderer = (data) => {
  return (
    <p
      style={{ fontFamily: "Encode Sans", paddingRight: 0 }}
      className={`ttype_cell ${getTextColor(data ? data : "")}`}
    >
      {data?.toUpperCase() || "-"}
    </p>
  );
};

const asscCellRenderer = (data) => {
  return (
    <p style={{ fontFamily: "Encode Sans" }} className="assc_cell">
      {data || "-"}
    </p>
  );
};

const instrumentNameCell = (data, a, b, index) => {
  return (
    <OverflowingText
      text={data}
      width={220}
      textClassName="infinity_transactions_instrument_name"
    />
  );
};

const columTransaction = [
  {
    label: "Instrument Name",
    key: "security_name",
    width: "270px",
    sortable: true,
    cellRenderer: instrumentNameCell,
  },
  {
    label: "Price",
    key: "rate",
    width: "145px",
    sortable: true,
    cellRenderer: navCellRenderer,
  },
  {
    label: "Qty",
    key: "quantity",
    width: "145px",
    sortable: true,
    cellRenderer: qtyCellRenderer,
  },
  {
    label: "Amount",
    key: "amount",
    classn: "nav_table_head",
    width: "141px",
    sortable: true,
    cellRenderer: amtCellRendererForRecent,
    cellRendererPdf: (data, row, key) => `${lakhAmt(data?.actual_value)}`,
  },
  {
    label: "Transaction Type",
    key: "type",
    width: "175px",
    sortable: true,
    cellRenderer: ttypeCellRenderer,
  },
  {
    label: "Asset Class",
    key: "asset_class",
    cellRenderer: asscCellRenderer,
    width: "175px",
  },
  {
    label: "Date",
    key: "transaction_date",
    width: "149px",
    sortable: true,
    cellRenderer: dateCellRenderer,
  },
  {
    label: "Expiry Date",
    key: "expiry_date",
    width: "149px",
    sortable: true,
    cellRenderer: dateCellRenderer,
  },
];

const columTransactionForPDF = [
  {
    label: "Instrument Name",
    key: "security_name",
    width: "300px",
    sortable: true,
  },
  {
    label: "Price",
    key: "rate",
    sortable: true,
    cellRenderer: navCellRenderer,
    cellRendererPdf: (data, row, key) => getExcelNumData2(data, false, 2),
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    cellRenderer: qtyCellRenderer,
  },
  {
    label: "Amount",
    key: "amount",
    classn: "nav_table_head",
    sortable: true,
    cellRenderer: amtCellRendererForRecent,
    cellRendererPdf: (data, row, key) => data?.actual_value || "-",
  },
  {
    label: "Transaction Type",
    key: "type",
    sortable: true,
    cellRenderer: ttypeCellRenderer,
  },
  {
    label: "Asset Class",
    key: "asset_class",
    cellRenderer: asscCellRenderer,
  },
  {
    label: "Sub Asset Class",
    key: "sub_asset_class",
    cellRenderer: asscCellRenderer,
  },
  {
    label: "Date",
    key: "transaction_date",
    sortable: true,
    cellRendererPdf: dateCellRendererForExportExcelPDF,
    cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
  },
  {
    label: "Expiry Date",
    key: "expiry_date",
    sortable: true,
    cellRendererPdf: dateCellRendererForExportExcelPDF,
    cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
  },
  {
    label: "Client Name",
    key: "client_name",
    sortable: true,
    cellRendererExcel: (data, row, key) => data,
    cellRendererPdf: (data, row, key) => data,
  },
  {
    label: "Account Name",
    key: "account_name",
    sortable: true,
    cellRendererExcel: (data, row, key) => data,
    cellRendererPdf: (data, row, key) => data,
  },
];

const TransactionsReportInfinity = observer(() => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchSuggetions, setSearchSuggetions] = useState([]);
  const [selectedSuggetion, setSelectedSuggetion] = useState(null);
  const [searchSuggetionOpen, setSearchSuggetionOpen] = useState("");
  //const [niftyMenu, setNiftyMenu] = useState(false);
  const [timePeriod, setTimePeriod] = useState(
    UserStore.transectionReportFilter.timePeriod,
  );
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(
    UserStore.transectionReportFilter.selectedMember,
  );
  const [allMembersMenuOpen, setAllMembersMenuOpen] = useState(false);
  const [selectedAssetClass, setSelectedAssetClass] = useState(
    UserStore.transectionReportFilter.selectedAssetClass,
  );
  // const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
  const [selectedAccount1, setSelectedAccount1] = useState(
    UserStore.transectionReportFilter.selectedAccount,
  );
  const [allAccountsMenuOpen1, setAllAccountsMenuOpen1] = useState(false);
  const [selectedTransecitonTypes, setSelectedTransecitonTypes] = useState(
    UserStore.transectionReportFilter.transectionType,
  );
  const [isSort, setSort] = useState("asc");
  //const [isPDFTableRendering, setIsPDFTableRendering] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);

  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [filteredColumn, setFilteredColumn] = useState("transaction_date");
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
  const [vertualRows, setVertualRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  const exportInfinityRef = useRef(null);
  const exportItemRefs = useRef([]);

  const loadingScreen = AuthStore.isLoadingFullScreen;
  const tableData = ReportsStore.transectionTableData;
  const reportFilter = UserStore.transectionReportFilter;

  const ref = useRef(null);
  const onClickOutside = useCallback((menu) => {
    switch (menu) {
      // case "export":
      //   setNiftyMenu(false);
      //   break;
      case "suggesion":
        setSearchSuggetionOpen(false);
        break;
      default:
        break;
    }
  }, []);

  const tableRef = useRef(null);

  useEffect(() => {
    if (AuthStore.isLoadingFullScreen) {
      setLoading(false);
    }
  }, [
    loadingScreen,
    //AuthStore.isLoadingFullScreen
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside("suggesion");
      }
      if (
        exportInfinityRef.current &&
        !exportInfinityRef.current.contains(event.target)
      ) {
        onClickOutside && onClickOutside("export");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      setTimeout(() => {
        document.removeEventListener("click", handleClickOutside, true);
      }, 10);
    };
  }, [onClickOutside]);

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };

  useEffect(() => {
    setVertualRows(ReportsStore.transectionTableData?.slice(0, 100));
  }, [
    tableData,
    //  ReportsStore.transectionTableData
  ]);

  useEffect(() => {
    setSelectedTransecitonTypes(
      UserStore.transectionReportFilter.transectionType,
    );
    setSelectedAssetClass(UserStore.transectionReportFilter.selectedAssetClass);
    setSelectedMember(UserStore.transectionReportFilter.selectedMember);
    setSelectedAccount1(UserStore.transectionReportFilter.selectedAccount);
    setTimePeriod(UserStore.transectionReportFilter.timePeriod);
  }, [
    reportFilter,
    //  UserStore.transectionReportFilter
  ]);

  useEffect(() => {
    if (selectedSuggetion) {
      const filtered = ReportsStore.transectionTableData?.filter(
        (eachTransaction) => {
          return selectedSuggetion
            ? eachTransaction?.security_name === selectedSuggetion?.title
            : true;
        },
      );
      ReportsStore.updateTransactionReportData(filtered);
    } else {
      ReportsStore.updateTableDataLoader(true);
      setTimeout(() => {
        ReportsStore.updateTableDataLoader(false);
      }, 2000);
      ReportsStore.updateTransactionReportData(
        ReportsStore.rememberedTransectionTableData,
      );
    }
  }, [selectedSuggetion]);

  function getFromAndToDate(timePeriod = "current_month") {
    let as_of_date = getAsOfDate(UserStore.asOfDate);
    if (!getAsOfDate(UserStore.asOfDate)) as_of_date = getCookie("asOfDate");
    const dateObjofAsOfDate = new Date(as_of_date);
    let newTodate;
    let formattedTodate;
    if (!resetedFromDate && !resetedToDate) {
      newTodate = new Date(UserStore.forReportsInceptionDate);
      formattedTodate =
        newTodate?.getFullYear() +
        "-" +
        padNumber(newTodate?.getMonth() + 1) +
        "-" +
        padNumber(newTodate?.getDate());
      setResetedFromDate(convertDateToObj(formattedTodate));
      setResetedToDate(convertDateToObj(as_of_date));
    }
    let formattedFromdate;
    let newFromdate;

    formattedFromdate =
      newFromdate?.getFullYear() +
      "-" +
      padNumber(newFromdate?.getMonth() + 1) +
      "-" +
      padNumber(newFromdate?.getDate());

    switch (timePeriod) {
      case "current_month":
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth(),
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        return {
          fromDate: convertDateToObj(formattedFromdate),
          toDate: convertDateToObj(as_of_date),
        };
      default:
        break;
    }
  }

  useEffect(() => {
    if (UserStore.isHydrated) {
      let as_of_date = getAsOfDate(UserStore.asOfDate);
      if (!getAsOfDate(UserStore.asOfDate)) as_of_date = getCookie("asOfDate");
      const dateObjofAsOfDate = new Date(as_of_date);
      let newTodate;
      let formattedTodate;
      if (!resetedFromDate && !resetedToDate) {
        newTodate = new Date(UserStore.forReportsInceptionDate);
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());
        setResetedFromDate(convertDateToObj(formattedTodate));
        setResetedToDate(convertDateToObj(as_of_date));
      }
      let formattedFromdate;
      let newFromdate;

      formattedFromdate =
        newFromdate?.getFullYear() +
        "-" +
        padNumber(newFromdate?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate?.getDate());

      const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
      const quarterStartDate = new Date(
        dateObjofAsOfDate.getFullYear(),
        currentQuarter * 3,
      );

      switch (timePeriod) {
        case "current_month":
          const dates = getFromAndToDate(timePeriod);
          setFromDate(dates.fromDate);
          setToDate(dates.toDate);
          break;
        case "previous_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth() - 1,
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          let dummyDateObj = new Date(as_of_date);
          let dummyTime = dummyDateObj?.setDate(1);
          newTodate = new Date(dummyTime - oneDayDif);
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            3,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 2
                : dateObjofAsOfDate.getFullYear() - 1
            }`,
            3,
            1,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            2,
            31,
          );
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_quarter":
          newFromdate = quarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_quarter":
          const currentQuarterStartDate = quarterStartDate;
          const currentQuarterEndDate = new Date(
            quarterStartDate.getFullYear(),
            quarterStartDate.getMonth() + 2,
            0,
          );
          const previousQuarterStartDate = new Date(
            currentQuarterStartDate.getFullYear(),
            currentQuarterStartDate.getMonth() - 3,
          );
          const previousQuarterEndDate = new Date(
            currentQuarterEndDate.getFullYear(),
            currentQuarterEndDate.getMonth() - 1,
            0,
          );
          newFromdate = previousQuarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = previousQuarterEndDate;
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "itd":
          newTodate = new Date(UserStore.forReportsInceptionDate);
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());

          setFromDate(convertDateToObj(formattedTodate));
          setToDate(convertDateToObj(as_of_date));
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [timePeriod, UserStore.isHydrated]);

  const handleKeyPress = (e) => {
    if (e.key === "ArrowDown" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[0].focus();
      }
    }
    if (e.key === "ArrowUp" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[suggetionElArr?.length - 1].focus();
      }
    }
  };

  const handleKeydownForSuggetion = (e) => {
    if (e.key === "Enter") {
      e.target.click();
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextEl = document.activeElement.nextElementSibling;
      if (!nextEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[0].focus();
        return;
      }
      nextEl.focus();
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevEl = document.activeElement.previousElementSibling;
      if (!prevEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[suggetionElArr?.length - 1].focus();
        return;
      }
      prevEl.focus();
      return;
    }
  };

  const SearchMenuContent = () => {
    return (
      <>
        {searchSuggetions?.length ? (
          <div
            className="suggetion_box_for_search"
            id="transaction_suggetion_box_for_search"
          >
            {searchSuggetions.map((suggetion) => (
              <div
                className="suggetion"
                tabIndex="0"
                key={suggetion.from}
                onKeyDown={handleKeydownForSuggetion}
                onClick={() => {
                  setSelectedSuggetion(suggetion);
                  setSearchSuggetionOpen(false);
                  setSearch(suggetion.title);
                  ReportsStore.updateTransectionReportTab(suggetion.from);
                }}
              >
                {suggetion.title}
              </div>
            ))}
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  // const AllAssetClassMenuContent = () => {
  //   const handleAssetClassChange = (changedAssetClass) => {
  //     if (changedAssetClass === "All") {
  //       if (
  //         selectedAssetClass === "All" ||
  //         ReportsStore.allAssetClassesData
  //           ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
  //           ?.every(Boolean)
  //       ) {
  //         setSelectedAssetClass([]);
  //       } else {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData.map((assetClass) => {
  //             return assetClass.id;
  //           }),
  //         );
  //       }
  //     } else {
  //       if (selectedAssetClass === "All") {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData
  //             .map((assetClass) => {
  //               return assetClass.id;
  //             })
  //             .filter((assetClassId) => assetClassId !== changedAssetClass),
  //         );
  //       } else {
  //         if (selectedAssetClass.includes(changedAssetClass)) {
  //           setSelectedAssetClass((prevState) => {
  //             return prevState.filter(
  //               (eachAssetClass) => eachAssetClass !== changedAssetClass,
  //             );
  //           });
  //         } else {
  //           setSelectedAssetClass([...selectedAssetClass, changedAssetClass]);
  //         }
  //       }
  //     }
  //   };
  //   return (
  //     <ul className="portfolio_report_accounts_container">
  //       <li
  //         className="account_listitem cursor"
  //         onClick={() => handleAssetClassChange("All")}
  //       >
  //         <div className="each_checkbox_wrapper">
  //           <input
  //             id={"all-asset-classes"}
  //             checked={
  //               selectedAssetClass === "All" ||
  //               ReportsStore.allAssetClassesData
  //                 ?.map((assetClass) =>
  //                   selectedAssetClass?.includes(assetClass.id),
  //                 )
  //                 ?.every(Boolean)
  //             }
  //             onChange={() => handleAssetClassChange("All")}
  //             type="checkbox"
  //             className="checkbox"
  //           />
  //           <label
  //             className="checkbox_label cursor"
  //             htmlFor="all-asset-classes"
  //           >
  //             All Asset Classes
  //           </label>
  //         </div>
  //       </li>
  //       {ReportsStore.allAssetClassesData?.map((assetClass, index) => (
  //         <li
  //           className="account_listitem cursor"
  //           onClick={() => handleAssetClassChange(assetClass.id)}
  //         >
  //           <div className="each_checkbox_wrapper">
  //             <input
  //               id={assetClass?.name}
  //               checked={
  //                 selectedAssetClass === "All" ||
  //                 selectedAssetClass.includes(assetClass.id)
  //                   ? true
  //                   : false
  //               }
  //               onChange={() => handleAssetClassChange(assetClass.id)}
  //               type="checkbox"
  //               className="checkbox"
  //             />
  //             <label
  //               className="checkbox_label cursor"
  //               for={assetClass.id}
  //               style={{ display: "contents" }}
  //               htmlFor={assetClass?.name}
  //             >
  //               <OverflowingText
  //                 text={
  //                   assetClass?.name
  //                     ? `${assetClass?.name
  //                         .charAt(0)
  //                         .toUpperCase()}${assetClass?.name
  //                         .slice(1)
  //                         .toLowerCase()}`
  //                     : assetClass?.name
  //                 }
  //                 width={140}
  //                 textClassName="radio_btn_label cursor_imp"
  //                 tooltipOnHover={true}
  //                 position="left"
  //                 tooltipClassName={
  //                   index === 0
  //                     ? "asset_class_tooltip_styles_bottom"
  //                     : "asset_class_tooltip_styles"
  //                 }
  //               />
  //             </label>
  //           </div>
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  const getAccountsList = () => {
    if (
      UserStore?.selectedClientId !== "0" &&
      getCookie("isPrimary") === "false"
    ) {
      return ReportsStore?.allAccountsData?.[
        UserStore?.selectedClientId
      ]?.flat();
    } else {
      if (selectedMember === "All") {
        if (ReportsStore?.allAccountsData) {
          return Object?.values(ReportsStore?.allAccountsData)?.flat();
        }
      } else if (ReportsStore?.allAccountsData) {
        return selectedMember
          ?.map(
            (eachMember) => ReportsStore?.allAccountsData[eachMember?.user_id],
          )
          ?.flat();
      }
    }
  };

  const AllAccountsMenuContent1 = () => {
    const handleChange = (account) => {
      setSelectedAccount1(account);
      setAllAccountsMenuOpen1(false);
    };

    return (
      <ul className="portfolio_report_accounts_container">
        <li
          className="account_listitem cursor"
          onClick={() => handleChange("All")}
        >
          <div className="radio_btn_input" onClick={() => handleChange("All")}>
            {selectedAccount1 === "All" ? <FilledButton /> : <EmptyButton />}
          </div>
          <label className="radio_btn_label cursor">All Accounts</label>
        </li>
        {getAccountsList()?.map((accountData) => (
          <li
            className="account_listitem cursor"
            onClick={() => handleChange(accountData)}
          >
            <div
              className="radio_btn_input"
              onClick={() => handleChange(accountData)}
            >
              {accountData?.account_Code === selectedAccount1?.account_Code ? (
                <FilledButton />
              ) : (
                <EmptyButton />
              )}
            </div>
            <label
              className="radio_btn_label cursor"
              for={accountData?.account_Code}
            >
              <OverflowingText
                text={accountData?.account_Name}
                width={160}
                textClassName="radio_btn_label cursor_imp"
                tooltipOnHover={true}
                position="left"
                tooltipClassName="accounts_tooltip_styles"
              />
            </label>
          </li>
        ))}
      </ul>
    );
  };

  const AllMembersMenuContent = () => {
    return (
      <ul className="portfolio_report_container">
        <ModalFamilyWithCheckboxes
          setSelectedMemberForReports={(id) => {
            setSelectedMember(id);
          }}
          isSort={isSort}
          setSort={setSort}
          selectedMemberForReports={selectedMember}
          showResetAndSubmit={false}
          searchBarWidth="351px"
        />
      </ul>
    );
  };

  const recentTransactionId = "recentTransactionId";

  // const ExtractDataContent = () => {
  //   const exportExcelClick = () => {
  //     exportExcel({
  //       isFamilyOnly: true,
  //       dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  //       sheetname: "Infinity Transactions",
  //       // customNameWithTime: getExcelPdfName(
  //       //   "",
  //       //   UserStore?.transectionReportFilter?.selectedMember,
  //       //   UserStore?.transectionReportFilter?.selectedAccount
  //       // ),
  //       columns: columTransactionForPDF,
  //       data: getTransactionsDataForPDF() || [],
  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(getAsOfDate(UserStore.asOfDate)),
  //         clientName:
  //           // UserStore.getData === "fam"
  //           // ?
  //           UserStore.userData?.family_name,
  //         //: UserStore.userData?.full_name,
  //       },
  //       excelName: `${getExcelPdfName(
  //         "Infinity Transactions Report -",
  //         UserStore?.transectionReportFilter?.selectedMember,
  //         UserStore?.transectionReportFilter?.selectedAccount,
  //       )} - ${getCurrentDate()}`,
  //     });
  //   };

  //   const exportPdf = async () => {
  //     // printDocument(recentTransactionId, {
  //     //   width: 850,
  //     //   height: 850,
  //     //   name: getExcelPdfName(
  //     //     "Infinity Transactions Report -",
  //     //     UserStore?.transectionReportFilter?.selectedMember,
  //     //     UserStore?.transectionReportFilter?.selectedAccount,
  //     //   ),
  //     // });
  //     if (isDownloading) return; // guard against double-click while already running
  //     setIsDownloading(true);
  //     try {
  //       await downloadPDFFile({
  //         headerName: "Transactions",
  //         fileId: recentTransactionId,
  //         isFamilyOnly: true,
  //         name: getExcelPdfName(
  //           "Infinity Transactions Report -",
  //           UserStore?.transectionReportFilter?.selectedMember,
  //           UserStore?.transectionReportFilter?.selectedAccount,
  //         ),
  //         dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  //         familyOrClientName: UserStore.userData?.family_name,
  //         columns:
  //           ReportsStore.selectedTabForTransaction === "recent_transaction"
  //             ? columTransactionForPDF
  //             : corporateActionsColumns,
  //         data:
  //           (ReportsStore.selectedTabForTransaction === "recent_transaction"
  //             ? getTransactionsDataForPDF()
  //             : getUpcomingTransactionsData()) || [],
  //       });
  //     } finally {
  //       setIsDownloading(false);
  //       setNiftyMenu(false);
  //     }
  //     //setIsPDFTableRendering(false);
  //   };

  //   return (
  //     <>
  //       <div ref={ref} className="extract_data_container downloadPdf">
  //         <p className="export_data_text">Export Data</p>
  //         <ul className="listitem_container">
  //           <li
  //             onClick={() => {
  //               exportExcelClick();
  //               setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export to Excel
  //           </li>
  //           <li
  //             onClick={() => {
  //               //setIsPDFTableRendering(true);
  //               exportPdf();
  //               //setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon pdf"></div> Export to PDF
  //           </li>
  //         </ul>
  //         {isDownloading && (
  //           <div className="popup_downloader">
  //             <img src={loaderGIF} alt="img" />
  //           </div>
  //         )}
  //       </div>
  //       <div></div>
  //     </>
  //   );
  // };

  useEffect(() => {
    if (UserStore.isHydrated) {
      ReportsStore.updateTableDataLoader(true);
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      ReportsStore.populateReportsData();
      ReportsStore.updateTransectionReportTab("recent_transaction");
      return () => {
        setTimeout(() => {
          ReportsStore.updateTableDataLoader(true);
          ReportsStore.updateTransectionFilter(
            {
              timePeriod: "current_month",
              transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
              selectedMember:
                (getDecodedToken()?.user_type === "employee" ||
                  getDecodedToken()?.user_type === "customer") &&
                UserStore.selectedClientId === "0"
                  ? "All"
                  : selectedMember !== "All"
                    ? selectedMember
                    : UserStore.transectionReportFilter.selectedMember,
              selectedAssetClass: "All",
              selectedAccount: "All",
              upcomingtransectionType: [
                "SIP",
                "STP",
                "SWP",
                "DRAWDOWN",
                "MATURITY",
              ],
            },
            "check12",
          );
        }, 10);
      };
    }
    // eslint-disable-next-line
  }, [UserStore.isHydrated]);

  useEffect(() => {
    if (
      ReportsStore.allAssetClassesAPIcallstate === "success" &&
      ReportsStore.allAccountsAPIcallstate === "success" &&
      ReportsStore.allMembersAPIcallstate === "success" &&
      UserStore.isHydrated
    ) {
      if (fromDate && toDate) {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
          isInfinity,
        );
      }
    }
    // eslint-disable-next-line
  }, [
    ReportsStore.allAssetClassesAPIcallstate,
    ReportsStore.allAccountsAPIcallstate,
    ReportsStore.allMembersAPIcallstate,
    UserStore.isHydrated,
  ]);

  useEffect(() => {
    if (
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "true") ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore.userData?.isprimary)
    ) {
      if (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      ) {
        setSelectedAccount1("All");
      }
    }
  }, [selectedMember]);

  const handleTranTypeChange = (clickedTranType, type) => {
    if (selectedTransecitonTypes.includes(clickedTranType)) {
      setSelectedTransecitonTypes((prevState) => {
        if (prevState.length !== 1) {
          return prevState.filter(
            (eachTranType) => eachTranType !== clickedTranType,
          );
        } else {
          return prevState;
        }
      });
    } else {
      setSelectedTransecitonTypes([
        ...selectedTransecitonTypes,
        clickedTranType,
      ]);
    }
  };

  const getHeadingForAssetClass = (selectedAssetClass) => {
    if (
      selectedAssetClass === "All" ||
      ReportsStore.allAssetClassesData
        ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
        ?.every(Boolean)
    ) {
      return "All Asset Classes";
    } else if (selectedAssetClass.length === 0) {
      return "None selected";
    } else {
      const data = ReportsStore?.allAssetClassesData
        ?.map((assetClass) =>
          selectedAssetClass?.includes(assetClass?.id) ? assetClass?.name : "",
        )
        .filter((selectedAssetClass) => selectedAssetClass);
      if (data?.length === 1) {
        return data?.[0];
      }

      return data.map((obj) => obj).join(", ");
    }
  };

  const getHeadingForMembers = (selectedMember) => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false") ||
      ((getDecodedToken()?.user_type === "customer" ||
        getDecodedToken()?.user_type === "employee") &&
        UserStore.currentFamilyMembers?.length === 1)
    ) {
      return UserStore?.userData?.full_name;
    } else {
      if (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      ) {
        return "All Members";
      } else if (selectedMember.length === 0) {
        return "None selected";
      } else {
        const data = selectedMember;
        if (data.length === 1) {
          return data[0].full_name;
        }

        return data.map((obj) => obj.full_name).join(", ");
      }
    }
  };

  const onApplyFilter = () => {
    setVertualRows([]);
    ReportsStore.updateTransactionReportData([]);
    setSearch("");
    setSelectedSuggetion(null);
    setFilteredColumn("transaction_date");
    setIsAscendingForHeader(false);
    if (!selectedMember?.length || !selectedAssetClass?.length) {
      ReportsStore.transectionTableData = [];
    } else {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.updateTransectionFilter(
        {
          timePeriod: timePeriod,
          transectionType: selectedTransecitonTypes,
          selectedMember:
            selectedMember?.length === UserStore.currentFamilyMembers?.length
              ? "All"
              : selectedMember !== "All"
                ? selectedMember
                : UserStore.transectionReportFilter.selectedMember,
          selectedAssetClass: selectedAssetClass,
          selectedAccount: selectedAccount1,
        },
        "check13",
      );
      if (fromDate && toDate) {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
          isInfinity,
        );
      }
    }
  };
  const onClearFilter = () => {
    setSearch("");
    setSelectedSuggetion(null);
    ReportsStore.updateTableDataLoader(true);
    ReportsStore.updateTransectionFilter(
      {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        selectedMember:
          getDecodedToken()?.user_type === "manager" ||
          (getDecodedToken()?.user_type === "employee" &&
            UserStore?.selectedClientId !== "0") ||
          (getDecodedToken()?.user_type === "customer" &&
            getDecodedToken()?.primary === "false") ||
          UserStore?.selectedClientId !== "0"
            ? UserStore.transectionReportFilter.selectedMember
            : "All",
        selectedAssetClass: "All",
        selectedAccount: "All",
      },
      "check14",
    );

    const { fromDate, toDate } = getFromAndToDate("current_month");

    if (fromDate && toDate) {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.getDataForTransectionReport(
        `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
        `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        isInfinity,
      );
    }
  };

  const getTransactionsData = () => {
    if (
      UserStore.transectionReportFilter.timePeriod === "last_10" &&
      vertualRows?.length > 10
    ) {
      return vertualRows?.slice(0, 10);
    } else {
      return vertualRows;
    }
  };

  const checkAccountsDropdownDisabled = () => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false") ||
      ((getDecodedToken()?.user_type === "customer" ||
        getDecodedToken()?.user_type === "employee") &&
        UserStore.currentFamilyMembers?.length === 1)
    ) {
      return false;
    } else if (selectedMember.length === 0) {
      return true;
    } else {
      return (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember?.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      );
    }
  };

  useEffect(() => {
    const vertualRows = ReportsStore.transectionTableData
      ? ReportsStore.transectionTableData
      : [];
    const tempSuggetionArr = [];

    vertualRows?.forEach((transaction) => {
      if (
        transaction.security_name
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase())
      ) {
        tempSuggetionArr.push({
          title: transaction.security_name,
          from: "recent_transaction",
        });
      }
    });

    if (search && tempSuggetionArr.length) {
      setSearchSuggetions(
        [...new Set(tempSuggetionArr.map((o) => JSON.stringify(o)))].map((s) =>
          JSON.parse(s),
        ),
      );
    } else {
      setSearchSuggetions([]);
      setSelectedSuggetion(null);
    }
  }, [search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    if (searchSuggetions.length) setSearchSuggetionOpen(true);
    else setSearchSuggetionOpen(false);
    if (!e.target.value) {
      setSelectedSuggetion(null);
    }
  };

  const isInfinity = UserStore.infinityData?.actual_value;

  const navigateToTransactionReport = (e) => {
    e.preventDefault();
    ReportsStore.updateTableDataLoader(true);
    navigate("/reports/transactions-report");
  };

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  const handleSortForTransaction = (filterType) => {
    setFilteredColumn(filterType);
    setIsAscendingForHeader(!isAscendingForHeader);
  };

  useEffect(() => {
    let rowData = search
      ? ReportsStore.transectionTableData
      : ReportsStore.rememberedTransectionTableData;
    if (rowData) {
      if (filteredColumn === "security_name" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "security_name" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "type" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "type" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "quantity" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "quantity" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "rate" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "rate" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "amount" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumn]?.actual_value).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "amount" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
                Number(b?.[filteredColumn]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "amount" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumn]?.actual_value).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "amount" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
                Number(b?.[filteredColumn]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "transaction_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "transaction_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (filteredColumn === "expiry_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "expiry_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
    // eslint-disable-next-line
  }, [filteredColumn, isAscendingForHeader]);

  const getTransactionsDataForPDF = () => {
    return ReportsStore.rememberedTransectionTableData;
  };

  // const getInitialfileName = () => {
  //   if (UserStore?.selectedClientId !== "0") {
  //     return UserStore?.userData?.family_name;
  //   } else {
  //     if (getAccountsList()?.length === 1) {
  //       return getAccountsList()?.[0]?.account_Name;
  //     } else if (
  //       UserStore?.transectionReportFilter?.selectedAccount !== "All"
  //     ) {
  //       return UserStore?.transectionReportFilter?.selectedAccount
  //         ?.account_Name;
  //     } else {
  //       return UserStore?.userData?.full_name;
  //     }
  //   }
  // };

  useLayoutEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
  }, []);

  useEffect(() => {
    trackEventWithScreen({
      eventName: REPORTS_PAGE,
      screenName: VIEW_TRANSACTIONS,
    });
    logEvents(REPORTS_PAGE, {
      screenName: VIEW_TRANSACTIONS,
    });
    return () => {
      ReportsStore.updateRememberedTransactionReportData([]);
      ReportsStore.updateTransactionReportData([]);
    };
  }, []);

  const handleScroll = () => {
    const scrollableContainer = tableRef.current;
    if (scrollableContainer) {
      const isAtEnd =
        Math.round(
          scrollableContainer.scrollTop + scrollableContainer.clientHeight,
        ) >= scrollableContainer.scrollHeight;
      if (isAtEnd) {
        if (vertualRows) {
          setVertualRows((prev) => {
            if (prev) {
              return [
                ...prev,
                ...ReportsStore.transectionTableData.slice(
                  prev?.length,
                  prev?.length + 100,
                ),
              ];
            }
          });
        }
      }
    }
  };

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Infinity Transaction Report"} />
          {loading ||
          AuthStore.isLoadingFullScreen ||
          (!UserStore.isHydrated &&
            !UserStore.forReportsInceptionDate &&
            !getAsOfDate(UserStore.asOfDate)) ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="reports" />
              <div className="reports_outer_main">
                <div className="transection_header_container">
                  <PageHeading headingClass="head" headingText="Transactions" />
                  <div className="search_extractdata_wrapper">
                    {isInfinity && (
                      <a
                        href="/transactions-report" // href used only for annoucement purpose and not as actual link
                        className="view_infinity_holdings_btn"
                        onClick={(e) => navigateToTransactionReport(e)} // e.preventDefault() this prevents from navigating to href link
                      >
                        <span className="darkBlueTextColor darkBlueBorderColor">
                          Back to Transactions
                        </span>
                      </a>
                    )}
                    <PopupMenu
                      MenuContent={SearchMenuContent}
                      open={searchSuggetionOpen}
                      setOpen={(flag) => {
                        setSearchSuggetionOpen(flag);
                        // setNiftyMenu(false);
                      }}
                      position={{ top: "50px", left: "0px" }}
                      showArrow={false}
                    >
                      <div className="search_input_container">
                        <img
                          className="search_icon"
                          src={search_svg}
                          alt="search"
                        />
                        <input
                          type="text"
                          id="search-box"
                          autoComplete="off"
                          className="search_input"
                          value={search}
                          placeholder="Search"
                          onKeyDown={handleKeyPress}
                          onChange={handleSearchChange}
                        />
                        <button
                          className="close_icon clickable"
                          onClick={() => setSearch("")}
                          aria-label="Clear Search"
                        >
                          <img src={closeInput} />
                        </button>
                      </div>
                    </PopupMenu>{" "}
                    {/* <div
                      ref={exportInfinityRef}
                      // onClick={() =>
                      //   !niftyMenu ? setNiftyMenu(true) : setNiftyMenu(false)
                      // }
                    >
                      <PopupMenu
                        position={{ top: "59px", right: "2px" }}
                        setOpen={(flag) => {
                          setNiftyMenu(flag);
                          setSearchSuggetionOpen(false);
                        }}
                        open={niftyMenu}
                        MenuContent={ExtractDataContent}
                      >
                        <div className="export_data_btn">
                          <p className="export_data_text">Export Data</p>
                          <div className="export_text_wrapper">
                            <p className="export_type">Excel</p>
                            <DownArrow />
                          </div>
                        </div>
                      </PopupMenu>
                    </div> */}
                    <div className="reports-export-wrapper">
                      <ExportReportList
                        exportExcel={() => {
                          exportExcel({
                            isFamilyOnly: true,
                            dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                            sheetname: "Infinity Transactions",
                            // customNameWithTime: getExcelPdfName(
                            //   "",
                            //   UserStore?.transectionReportFilter?.selectedMember,
                            //   UserStore?.transectionReportFilter?.selectedAccount
                            // ),
                            columns: columTransactionForPDF,
                            data: getTransactionsDataForPDF() || [],
                            reportDetails: {
                              relatioshipManager:
                                UserStore?.exportDetails?.find(
                                  (item) => item.role === "RM",
                                )?.name,
                              serviceManager: UserStore?.exportDetails?.find(
                                (item) => item.role === "CXO",
                              )?.name,
                              date: getPrintDate(
                                getAsOfDate(UserStore.asOfDate),
                              ),
                              clientName:
                                // UserStore.getData === "fam"
                                // ?
                                UserStore.userData?.family_name,
                              //: UserStore.userData?.full_name,
                            },
                            excelName: `${getExcelPdfName(
                              "Infinity Transactions Report -",
                              UserStore?.transectionReportFilter
                                ?.selectedMember,
                              UserStore?.transectionReportFilter
                                ?.selectedAccount,
                            )} - ${getCurrentDate()}`,
                          });
                        }}
                        exportPdf={async () => {
                          // printDocument(recentTransactionId, {
                          //   width: 850,
                          //   height: 850,
                          //   name: getExcelPdfName(
                          //     "Infinity Transactions Report -",
                          //     UserStore?.transectionReportFilter?.selectedMember,
                          //     UserStore?.transectionReportFilter?.selectedAccount,
                          //   ),
                          // });
                          if (isDownloading) return; // guard against double-click while already running
                          setIsDownloading(true);
                          try {
                            await downloadPDFFile({
                              headerName: "Transactions",
                              fileId: recentTransactionId,
                              isFamilyOnly: true,
                              name: getExcelPdfName(
                                "Infinity Transactions Report -",
                                UserStore?.transectionReportFilter
                                  ?.selectedMember,
                                UserStore?.transectionReportFilter
                                  ?.selectedAccount,
                              ),
                              dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                              familyOrClientName:
                                UserStore.userData?.family_name,
                              columns:
                                ReportsStore.selectedTabForTransaction ===
                                "recent_transaction"
                                  ? columTransactionForPDF
                                  : corporateActionsColumns,
                              data:
                                (ReportsStore.selectedTabForTransaction ===
                                "recent_transaction"
                                  ? getTransactionsDataForPDF()
                                  : getUpcomingTransactionsData()) || [],
                            });
                          } finally {
                            setIsDownloading(false);
                            //setNiftyMenu(false);
                          }
                          //setIsPDFTableRendering(false);
                        }}
                        buttonProps={{
                          buttonType: "reportExport",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                          containerClass: "downloadPdf",
                        }}
                        restrictHover={true}
                        itemRefs={exportItemRefs}
                        menuItems={exportDataMenu}
                        accessibilityValues={{
                          buttonId: "export-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "extract-menu",
                          ariaLabel: "Extract Data",
                        }}
                      >
                        <>
                          {isDownloading && (
                            <div className="popup_downloader">
                              <img src={loaderGIF} alt="img" />
                            </div>
                          )}
                        </>
                      </ExportReportList>
                    </div>
                  </div>
                </div>
                <div className="reports_yellow_container">
                  <div className="transecitons_yellow_wrapper">
                    <div className="transections_first_container">
                      <div className={`time_period_container`}>
                        <RadioGroup
                          heading="Time Period"
                          name="time_period"
                          radioBtnArray={transectionsTimePeriodRadioBtnsData}
                          handleChange={handleTimePeriodChange}
                          value={timePeriod}
                          radioBtnsPerRow={4}
                          groupId={"infinity-transaction-time-period"}
                          groupName={"infinity-transaction-radio-group1"}
                        />
                        <DatePicker2
                          timePeriod={timePeriod}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          initialFromDate={initialFromDate}
                          initialToDate={initialToDate}
                          resetedFromDate={resetedFromDate}
                          resetedToDate={resetedToDate}
                          handleReset={handleTimePeriodReset}
                          // isActive={timePeriod === "custom"}
                          isActive={true}
                          open={datePickerModalOpen}
                          setOpen={() => {
                            handleTimePeriodChange("custom");
                            setDatePickerModalOpen(true);
                          }}
                          onClose={() => setDatePickerModalOpen(false)}
                        />
                      </div>
                    </div>
                    <div className="transections_second_container">
                      <div
                        className="transection_type_container"
                        role="group"
                        aria-labelledby="transaction-type-heading"
                      >
                        <h2
                          id="transaction-type-heading"
                          className="transection_type_heading"
                        >
                          Transaction Type
                        </h2>
                        <div className="transection_type_checkboxes">
                          <>
                            <div
                              className={
                                selectedTransecitonTypes?.includes("BOUGHT") &&
                                selectedTransecitonTypes?.length === 1
                                  ? "each_checkbox_wrapper"
                                  : "each_checkbox_wrapper  cursor"
                              }
                              onClick={() => handleTranTypeChange("BOUGHT")}
                            >
                              <input
                                id="bought"
                                style={{
                                  cursor:
                                    selectedTransecitonTypes?.includes(
                                      "BOUGHT",
                                    ) && selectedTransecitonTypes?.length === 1
                                      ? "text"
                                      : "pointer",
                                }}
                                checked={selectedTransecitonTypes?.includes(
                                  "BOUGHT",
                                )}
                                type="checkbox"
                                className="checkbox"
                              />
                              <label htmlFor="bought" className="unitFont">
                                Bought
                              </label>
                            </div>
                            <div
                              className={
                                selectedTransecitonTypes?.includes("SOLD") &&
                                selectedTransecitonTypes?.length === 1
                                  ? "each_checkbox_wrapper"
                                  : "each_checkbox_wrapper  cursor"
                              }
                              onClick={() => handleTranTypeChange("SOLD")}
                            >
                              <input
                                id="sold"
                                style={{
                                  cursor:
                                    selectedTransecitonTypes?.includes(
                                      "SOLD",
                                    ) && selectedTransecitonTypes?.length === 1
                                      ? "text"
                                      : "pointer",
                                }}
                                checked={selectedTransecitonTypes?.includes(
                                  "SOLD",
                                )}
                                type="checkbox"
                                className="checkbox"
                              />
                              <label htmlFor="sold" className="unitFont">
                                Sold
                              </label>
                            </div>
                            <div
                              className={
                                selectedTransecitonTypes?.includes("BONUS") &&
                                selectedTransecitonTypes?.length === 1
                                  ? "each_checkbox_wrapper"
                                  : "each_checkbox_wrapper  cursor"
                              }
                              onClick={() => handleTranTypeChange("BONUS")}
                            >
                              <input
                                id="bonus"
                                style={{
                                  cursor:
                                    selectedTransecitonTypes?.includes(
                                      "BONUS",
                                    ) && selectedTransecitonTypes?.length === 1
                                      ? "text"
                                      : "pointer",
                                }}
                                checked={selectedTransecitonTypes?.includes(
                                  "BONUS",
                                )}
                                type="checkbox"
                                className="checkbox"
                              />
                              <label htmlFor="bonus" className="unitFont">
                                Bonus
                              </label>
                            </div>
                            <div
                              className={
                                selectedTransecitonTypes?.includes("SPLIT") &&
                                selectedTransecitonTypes?.length === 1
                                  ? "each_checkbox_wrapper"
                                  : "each_checkbox_wrapper  cursor"
                              }
                              onClick={() => handleTranTypeChange("SPLIT")}
                            >
                              <input
                                id="split"
                                style={{
                                  cursor:
                                    selectedTransecitonTypes?.includes(
                                      "SPLIT",
                                    ) && selectedTransecitonTypes?.length === 1
                                      ? "text"
                                      : "pointer",
                                }}
                                checked={selectedTransecitonTypes?.includes(
                                  "SPLIT",
                                )}
                                type="checkbox"
                                className="checkbox"
                              />
                              <label htmlFor="split" className="unitFont">
                                Split
                              </label>
                            </div>
                          </>
                        </div>
                      </div>
                      <div className="dropdown_container infinity">
                        <AssetClassesCheckBox
                          heading={getHeadingForAssetClass(selectedAssetClass)}
                          position={{
                            top: "56px",
                            left: "0px",
                            zIndex: "20",
                            padding: "3px",
                            overflowY: "hidden",
                            border: "1px solid #e3e3e3",
                          }}
                          showArrow={false}
                          headingValue={selectedAssetClass}
                          allData={ReportsStore.allAssetClassesData}
                          setHeadingValue={(changedAssetClass) => {
                            if (changedAssetClass === "All") {
                              if (
                                selectedAssetClass === "All" ||
                                ReportsStore.allAssetClassesData
                                  ?.map((assetClass) =>
                                    selectedAssetClass?.includes(assetClass.id),
                                  )
                                  ?.every(Boolean)
                              ) {
                                setSelectedAssetClass([]);
                              } else {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData?.map(
                                    (assetClass) => {
                                      return assetClass?.id;
                                    },
                                  ),
                                );
                              }
                            } else {
                              if (selectedAssetClass === "All") {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData
                                    ?.map((assetClass) => {
                                      return assetClass?.id;
                                    })
                                    .filter(
                                      (assetClassId) =>
                                        assetClassId !== changedAssetClass,
                                    ),
                                );
                              } else {
                                if (
                                  selectedAssetClass?.includes(
                                    changedAssetClass,
                                  )
                                ) {
                                  setSelectedAssetClass((prevState) => {
                                    return prevState.filter(
                                      (eachAssetClass) =>
                                        eachAssetClass !== changedAssetClass,
                                    );
                                  });
                                } else {
                                  setSelectedAssetClass([
                                    ...selectedAssetClass,
                                    changedAssetClass,
                                  ]);
                                }
                              }
                            }
                          }}
                          //showPopup={true}
                          showArrow={false}
                          // disabledPopup={
                          //   ReportsStore.usersAccounts.length === 1
                          // }
                          //isDisabled={false}
                          popupClassName={{
                            wrapperClass:
                              "popup_menu_container dropdown-wrapper",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={[
                            {
                              id: "All",
                              name: "All Asset Classes",
                            },
                          ].concat(ReportsStore.allAssetClassesData)}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "listbox",
                            ariaControls: "asset-listbox",
                            ariaLabel: "Asset Class Filters",
                          }}
                        />
                        <GoldenDropDown
                          heading={getHeadingForMembers(selectedMember)}
                          selectedMember={selectedMember}
                          showPopup={
                            getDecodedToken()?.user_type === "manager" ||
                            (getDecodedToken()?.user_type === "employee" &&
                              UserStore?.selectedClientId !== "0") ||
                            (getDecodedToken()?.user_type === "customer" &&
                              getDecodedToken()?.primary === "false") ||
                            UserStore?.selectedClientId !== "0" ||
                            ((getDecodedToken()?.user_type === "customer" ||
                              getDecodedToken()?.user_type === "employee") &&
                              UserStore.currentFamilyMembers?.length === 1)
                              ? false
                              : true
                          }
                          popupMenuClass="reports_select_family_member_popup_menu"
                          ReportMenuContent={AllMembersMenuContent}
                          reportsMenuOpen={allMembersMenuOpen}
                          setReportsMenuOpen={setAllMembersMenuOpen}
                          position={{
                            top: "57px",
                            left: "0px",
                            minWidth: "380px",
                          }}
                          showArrow={false}
                          dropDownContainerClass="all_members_dropdown"
                          popUpId={"all-members-combobox"}
                          popUpRole={"combobox"}
                          ariaHasPopUp={"dialog"}
                          ariaControls={"all-members-listbox"}
                          aria-labelledby="all-members-label"
                        />
                        <div style={{ display: "none" }}>
                          <GoldenDropDown
                            heading={
                              selectedAccount1 !== "All"
                                ? selectedAccount1.account_Name
                                : selectedMember.length === 0
                                  ? "None selected"
                                  : "All Accounts"
                            }
                            ReportMenuContent={AllAccountsMenuContent1}
                            isDisabled={checkAccountsDropdownDisabled()}
                            showPopup={true}
                            reportsMenuOpen={allAccountsMenuOpen1}
                            setReportsMenuOpen={setAllAccountsMenuOpen1}
                            position={{
                              top: "56px",
                              left: "0px",
                              zIndex: "20",
                              padding: "3px",
                              overflowY: "hidden",
                              border: "1px solid #e3e3e3",
                            }}
                            showArrow={false}
                            dropDownContainerClass="all_accounts_dropdown"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <ApplyFilter
                    customCss="reusable-button"
                    onApplyFilter={onApplyFilter}
                    onClearFilter={onClearFilter}
                  />
                </div>
                {ReportsStore.tableDataLoader ||
                (vertualRows?.length === 0 &&
                  (ReportsStore.transectionTableData?.length ||
                    ReportsStore.rememberedTransectionTableData.length)) ? (
                  <div className="report_table_loader">
                    <div className="report_loader_wrapper">
                      <img
                        className="loading_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  </div>
                ) : (
                  <div className="infinity_holdings_bg">
                    <div
                      className="transaction_container extra-padding-30"
                      style={{ display: "flex" }}
                    >
                      <div
                        ref={tableRef}
                        className="transaction_table_container"
                        onScroll={handleScroll}
                      >
                        {ReportsStore.transectionTableData?.length &&
                        !ReportsStore.tableDataLoader ? (
                          <Table
                            data={getTransactionsData()}
                            columns={columTransaction}
                            tableClass="custom_table2 for_table reports-table"
                            handleSort={handleSortForTransaction}
                            sortKey={filteredColumn}
                            isAscending={isAscendingForHeader}
                          />
                        ) : (
                          <div className="empty_state_for_valuation">
                            <EmptyDerivatives
                              image={emptyIcon}
                              message="You do not have any records to display"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* {(isPDFTableRendering || true) && (
                <PdfTable
                  isFamilyOnly={true}
                  headerName={"Infinity Transactions"}
                  columns={columTransactionForPDF}
                  data={getTransactionsDataForPDF() || []}
                  id={recentTransactionId}
                  familyOrClientName={
                    UserStore.userData?.family_name
                    //   getExcelPdfName(
                    //   "",
                    //   UserStore?.transectionReportFilter?.selectedMember,
                    //   UserStore?.transectionReportFilter?.selectedAccount
                    // )
                  }
                  dateRange={`${getDateString(fromDate)} To ${getDateString(
                    toDate,
                  )}`}
                />
              )} */}
            </>
          )}
        </div>
      )}
    </Observer>
  );
});

export default TransactionsReportInfinity;
